// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

// Internal Dependencies
import Colours from '../styles/colours';
import MText from './Common/MText';

const MBadge = ({ text, textColour, colour, style, onClick }) => (
  <Button
    className="badge badge-pill py-2 px-4"
    style={{
      background:   colour,
      borderRadius: '30px',
      width:        'auto',
      ...style,
    }}
    onClick={onClick}
  >
    <MText text={text} colour={textColour || Colours.Black} />
  </Button>
);

export default MBadge;

MBadge.propTypes = {
  text:       PropTypes.string,
  textColour: PropTypes.string,
  colour:     PropTypes.string,
  style:      PropTypes.shape(Object),
  onClick:    PropTypes.func,
};

MBadge.defaultProps = {
  text:       null,
  textColour: Colours.White,
  colour:     Colours.Black,
  style:      {},
  onClick:    () => {},
};
